var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxAlarmOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7275 12.4726C15.4862 12.0313 15.3598 11.5364 15.3598 11.0335V8.71457C15.3598 5.16826 12.9632 2.80005 10.0002 2.80005C7.03724 2.80005 4.64104 5.16826 4.64104 8.71457V11.0331C4.64104 11.5363 4.51448 12.0314 4.273 12.4729L3.48572 13.9121C3.267 14.3119 3.55636 14.8 4.01211 14.8H10H15.9881C16.4438 14.8 16.7332 14.3121 16.5146 13.9122L15.7275 12.4726Z",
    stroke: "currentColor",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.8V14.8872C7.5 15.5402 7.77885 16.1621 8.26641 16.5965C8.5826 16.8782 8.97073 17.0667 9.38763 17.1409L9.51697 17.164C9.83647 17.2209 10.1635 17.2209 10.483 17.164L10.6124 17.1409C11.0293 17.0667 11.4174 16.8782 11.7336 16.5965C12.2211 16.1621 12.5 15.5402 12.5 14.8872V14.8",
    stroke: "currentColor",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxAlarmOutline);
export default __webpack_public_path__ + "static/media/icon_20px_alarm_outline.73262e94aab8ae5e7bda0d6a158cb6c0.svg";
export { ForwardRef as ReactComponent };